import { BaseClient } from './baseClient';

export interface ResearchNotificationPrefs {
    notifyOnResearchDone: boolean;
    emailPromise: boolean;
}

interface Envelope<T> {
    success: boolean;
    data: T;
}

/** Per-RFQ notification choices of the RFQ's owner ("Don't email me"). */
class RfqNotificationPrefsClient extends BaseClient {
    async update(rfqId: string, prefs: { notifyOnResearchDone: boolean }): Promise<ResearchNotificationPrefs> {
        const response = await this.api.patch<Envelope<ResearchNotificationPrefs>>(
            `/trp/rfqs/${rfqId}/notification-preferences`,
            prefs,
        );
        return response.data.data;
    }
}

export const rfqNotificationPrefsClient = new RfqNotificationPrefsClient();
